<div class="alert alert-success {{addClass}}" role="alert" *ngIf="model?.success_message" [innerHTML]="model?.success_message"></div>
<div class="alert alert-warning {{addClass}}" role="alert" *ngIf="model?.error_message" [innerHTML]="model?.error_message"></div>
<div class="alert alert-warning" role="alert" *ngIf="model.validations?.length > 0" >
 <ng-template [ngIf]="model.validations.length == 1"> {{model.validations[0].message}}</ng-template>
 <ng-template [ngIf]="model.validations.length > 1">
   <ul class="mb-0" *ngFor="let validation of model.validations" >
    <li>{{validation.message}}</li>
   </ul>
</ng-template>
</div>
